import { ChangeDetectionStrategy, Component, DestroyRef, ElementRef, inject } from "@angular/core";
import { ForgeButtonModule, ForgeIconButtonModule, ForgeIconModule, ForgeInlineMessageModule, ForgeScaffoldModule, ForgeToolbarModule } from "@tylertech/forge-angular";
import { WINDOW } from "@tylertech/shared-module";
import { SystemInfoService, TylerAssistantSidebarService } from "../../../services";
import { SUPPORT_PORTAL_URL, productSupportUrl } from "../supportLinks";
import { publishRightPanelWidth } from "./rightPanelWidth";

@Component({
    selector: "tyler-assistant-unavailable",
    templateUrl: "./tylerAssistantUnavailable.tmpl.html",
    styleUrls: ["./tylerAssistantUnavailable.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ForgeButtonModule,
        ForgeIconButtonModule,
        ForgeIconModule,
        ForgeInlineMessageModule,
        ForgeScaffoldModule,
        ForgeToolbarModule,
    ]
})
export class TylerAssistantUnavailableComponent
{
    private readonly $tylerAssistantSidebarService = inject(TylerAssistantSidebarService);
    private readonly window = inject<globalThis.Window>(WINDOW);

    protected readonly supportPortalUrl = SUPPORT_PORTAL_URL;
    protected readonly productSupportUrl = productSupportUrl(inject(SystemInfoService).systemInfo?.Product);

    constructor()
    {
        const stopPublishing = publishRightPanelWidth(inject(ElementRef).nativeElement);
        inject(DestroyRef).onDestroy(stopPublishing);
    }

    protected open(url: string): void
    {
        this.window.open(url, "_blank");
    }

    protected close(): void
    {
        this.$tylerAssistantSidebarService.fallbackOpen.set(false);
    }

    protected tryAgain(): void
    {
        this.$tylerAssistantSidebarService.requestReconnect();
    }
}
